<div class="container">
  <div class="header">
    <div class="header-left">
      <pdq-button (onClick)="backToLocations()" variant="light" size="large" icon="side_left_arrow"></pdq-button>
      <p class="title">{{ pageTitle }}</p>
    </div>
  </div>
  @if (showDangerBanner) {
    <pdq-banner class="banner" variant="danger" bannerTitle="Not verified: needs your attention"
      ><ul>
        @for (error of postSubmitErrors; track error) {
          <li>{{ error }}</li>
        }
      </ul>
    </pdq-banner>
  }

  <div class="form-container">
    <pdq-input
      label="Location name"
      variant="form"
      placeholder="Enter location name"
      [value]="locationForm.controls.locationName.value"
      [control]="locationForm.controls.locationName"
      [dirty]="locationForm.controls.locationName.dirty"></pdq-input>
    <pdq-input
      label="Address"
      variant="form"
      placeholder="Enter address"
      showBrowserAutocomplete="off"
      [autocompleteRef]="intAutoCompleteRef"
      [autocompleteMode]="autoCompleteMode !== 'IL'"
      autoCompleteWidth="360"
      [invalid]="!isValidAddress"
      autoCompletePlacement="top"
      [value]="locationForm.controls.address1.value"
      [control]="locationForm.controls.address1"
      [dirty]="locationForm.controls.address1.dirty"></pdq-input>
    @if (autoCompleteMode !== 'IL') {
      <address-autocomplete
        placement="top"
        [country]="autoCompleteMode"
        [query]="locationForm.value.address1"
        [control]="locationForm.controls.address1"
        (autoCompleteInit)="initIntAutoComplete($event)"
        (autoCompleteSelected)="onAutoCompleteSelected($event)"></address-autocomplete>
    }
    <pdq-input
      label="Apartment, suite, etc. (optional)"
      variant="form"
      placeholder="Enter apartment, suite, etc."
      [invalid]="!isValidAddress"
      [value]="locationForm.controls.address2.value"
      [control]="locationForm.controls.address2"
      [dirty]="locationForm.controls.address2.dirty"></pdq-input>
    <pdq-input
      label="City"
      placeholder="Enter city"
      variant="form"
      [value]="locationForm.controls.city.value"
      [invalid]="!isValidAddress"
      [control]="locationForm.controls.city"
      [dirty]="locationForm.controls.city.dirty"
      [autocompleteMode]="autoCompleteMode === 'IL'"
      [autocompleteRef]="cityAutoCompleteRef"></pdq-input>
    <city-autocomplete
      (onAutoCompleteSelected)="setCity($event)"
      (onAutoCompleteRefInit)="initCityAutoComplete($event)"
      [enabled]="autoCompleteMode === 'IL'"
      [control]="locationForm.controls.city">
    </city-autocomplete>
    <div class="field-group">
      <pdq-dropdown
        title="Country/Region"
        (onChange)="handleCountryChange($event)"
        [defaultOption]="countryDefault"
        fullWidth="true"
        [disabled]="!isEditable"
        [options]="countryOptions"></pdq-dropdown>

      @if (locationForm.controls.country.value !== 'Israel') {
        <pdq-input
          variant="form"
          [invalid]="!isValidAddress"
          [placeholder]="locationForm.controls.country.value === 'Canada' ? 'Enter province' : 'Enter state'"
          [label]="locationForm.controls.country.value === 'Canada' ? 'Province' : 'State'"
          [value]="locationForm.controls.province.value"
          [control]="locationForm.controls.province"
          [dirty]="locationForm.controls.province.dirty"></pdq-input>
      }

      <pdq-input
        variant="form"
        label="ZIP code"
        placeholder="Enter zip code"
        [invalid]="!isValidAddress"
        [value]="locationForm.controls.zip.value"
        [control]="locationForm.controls.zip"
        [dirty]="locationForm.controls.zip.dirty"></pdq-input>
    </div>
    <pdq-input
      variant="form"
      label="Phone"
      placeholder="Enter phone"
      [value]="locationForm.controls.phone.value"
      [control]="locationForm.controls.phone"
      [dirty]="locationForm.controls.phone.dirty"></pdq-input>
  </div>
  <div class="footer">
    <div class="actions">
      <pdq-button [loading]="isSaving" (onClick)="saveAddress()" variant="light" [disabled]="locationForm.pristine"
        >Save</pdq-button
      >
    </div>
  </div>
  <custom-shipping-day [address]="address"></custom-shipping-day>
</div>
